import React, {useMemo} from "react"
import { useUserOrgs } from "../../hooks/use-user"
import ProjectTable from "../../components/project-list/project-table"
import { Loading } from "../../components/loading"
import { withAuthenticationRequired } from '@auth0/auth0-react';

const ProjectDetail = props => {
  const { loading } = useUserOrgs()
  const { path, id, parentOrganization, location } = props
  const components = useMemo(function (){
    if (path === "/projects/:parentOrganization/private/:id") {
      const defaultReturnTo = () =>typeof window !== `undefined` ? `${window.location.pathname}${window.location.hash}`:null;
      const PrivateComponent = withAuthenticationRequired(()=><ProjectTable projectSlug={id} parentOrganization={parentOrganization} path={path} location={location}/>,{returnTo: defaultReturnTo});
      return <PrivateComponent {...props}/>
    } else {
      return <ProjectTable projectSlug={id} parentOrganization={parentOrganization} path={path} location={location}/>
    }
  }, [])

  if (loading) {
    return <Loading />
  }

  return components
}

export default ProjectDetail
